import React, {useState} from 'react';
import {buildCSSFormGroupInput} from "../../../../utils/BubblyUIUtils";
import {doesEmailRespectPattern,isPasswordValid,iStringAName} from "../../../../utils/BubblyUtils";
import AgreementComponent from "./AgreementComponent";
import {withToastManager} from "react-toast-notifications";
import { withRouter } from 'react-router-dom';
import AuthenticationService from "../../../../services/Authentication/AuthenticationService";
import LoadingIndicator from "../../../meta/LoadingIndicator";

function RegisterForm(props){

    const [fullname, updateFullname] = useState("");
    const [email, updateEmail] = useState("");
    const [password, updatePassword] = useState("");
    const [showPassword, updateShowPassword] = useState(false);
    const [userAgreementAccepted, updateUserAgreementAccepted] = useState(false);

    const [fullnameValid, updateFullnameValid] = useState();
    const [emailValid, updateEmailValid] = useState();
    const [passwordValid, updatePasswordValid] = useState();

    const [registerLoading, updateRegisterLoading] = useState();

    function toggleAgreement() {
        updateUserAgreementAccepted(!userAgreementAccepted);
    }

    function toggleShowPassword() {
        updateShowPassword(!showPassword);
    }

    function onFullnameChange(event) {
        const fullname = event.target.value;
        updateFullname(fullname);
        const isFullnameValid = iStringAName(fullname);
        updateFullnameValid(isFullnameValid);
        buildCSSFormGroupInput(event, "registerFullnameFormGroupId", "registerFullnameFormGroupErrorId", isFullnameValid);
    }

    function onEmailChange(event){
        var email = event.target.value;
        if(email.includes(" ")){
            return;
        }

        updateEmail(email);
        if (doesEmailRespectPattern(email)) {
            AuthenticationService.checkIfEmailIsValid(email,
                (success) => {
                    const emailIsValid = !!success.data;
                    updateEmailValid(emailIsValid);
                    buildCSSFormGroupInput(event, "registerEmailFormGroupId", "registerEmailFormGroupErrorId", emailIsValid);
                },
                (error) => {
                    props.toastManager.add("Error! Cannot check email validity!", {
                        appearance: 'error'
                    });
                    updateEmailValid(false);
                    buildCSSFormGroupInput(event, "registerEmailFormGroupId", "registerEmailFormGroupErrorId", false);
                }
            );
        } else {
            updateEmailValid(false);
            buildCSSFormGroupInput(event, "registerEmailFormGroupId", "registerEmailFormGroupErrorId", false);
        }
    }

    function onPasswordChange(event) {
        const password = event.target.value;
        updatePassword(password);
        const passwordValid = isPasswordValid(password);
        updatePasswordValid(passwordValid);
        buildCSSFormGroupInput(event, "registerPasswordFormGroupId", "registerPasswordFormGroupErrorId", passwordValid);
    }

    function handleRegisterFormSubmit(event) {
        const userData = {
            user_fullname: fullname,
            user_email: email,
            user_password: password,
            user_agreement: userAgreementAccepted
        };

        updateRegisterLoading(true);
        AuthenticationService.defaultRegister(
            userData,
            (success) => {
                const goToLink = "/confirm-account?user_id=" + success.data;
                props.history.push(goToLink);
            },
            (error) => {
                props.toastManager.add("Error while trying to register user! Try again! If it's not working contact Questia!", {
                    appearance: 'error'
                });
                updateRegisterLoading(false);
            }
        );

        event.preventDefault();
    }

    const registerButtonDisabled = !fullnameValid || !emailValid || !passwordValid || !userAgreementAccepted || registerLoading;
    const registerButtonClassName = "cta--normal cta--fullwidth cta--notransform " + (registerButtonDisabled ? " cta--soft-disabled " : "");

    return(
        <React.Fragment>
            <form action="" className="form" onSubmit={handleRegisterFormSubmit}>
                <div className="form__group" id="registerFullnameFormGroupId">
                    <div className="form__group__input">
                        <input className="form__group__input__text" type="text" placeholder="Your Name" onChange={onFullnameChange} disabled={registerLoading}/>
                            <span className="form__group__input__icon"><img src="./assets/img/login_page/user.png"
                                                                            alt=""/></span>
                    </div>
                    <span className="form__group__error form__group__error--name" id="registerFullnameFormGroupErrorId">Please specify a name</span>
                </div>
                <div className="form__group" id="registerEmailFormGroupId">
                    <div className="form__group__input">
                        <input className="form__group__input__text" type="text" placeholder="youremail@example.com" value={email} onChange={onEmailChange} disabled={registerLoading}/>
                            <span className="form__group__input__icon"><img src="./assets/img/login_page/mail.png"
                                                                            alt=""/></span>
                            <span className="form__group__input_check"><img
                                src="./assets/img/login_page/icon-check--green.png" alt=""/></span>
                    </div>
                    <span className="form__group__error form__group__error--email" id="registerEmailFormGroupErrorId">Email is invalid or is already associated with an account.</span>
                </div>
                <div className="form__group" id="registerPasswordFormGroupId">
                    <div className="form__group__input">
                        <input className="form__group__input__text password-input-js"
                               type={showPassword ? "text" : "password"}
                               placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;"
                               onChange={onPasswordChange} disabled={registerLoading}/>
                            <span className="form__group__input__toggle" onClick={toggleShowPassword}></span>
                            <span className="form__group__input__icon"><img src="./assets/img/login_page/lock.png"
                                                                            alt=""/></span>
                    </div>
                    <div className="form__group__password-str form__group__password-str--lvl0">
                        <div className="form__group__password-str__bar">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        <span className="form__group__password-str__msg"></span>
                    </div>
                    <span className="form__group__error form__group__error--email" id="registerPasswordFormGroupErrorId">Please enter at least 8 characters</span>
                </div>

                <AgreementComponent formClass={"form__group pt-xl"} userAgreementAccepted={userAgreementAccepted} handleToggleUserAgreementAccepted={toggleAgreement} disabled={registerLoading}/>

                { registerLoading && <LoadingIndicator/> }
                { !registerLoading &&
                    (
                        <div className="cta__wrapp pt-xs">
                            <input type="submit"
                                   id="registerFormSubmitButtonId"
                                   disabled={registerButtonDisabled}
                                   className={registerButtonClassName} value="Sign up with Email"/>
                        </div>
                    )
                }

            </form>
        </React.Fragment>
    )
}

export default withRouter(withToastManager(RegisterForm));